import _UIViewImplementation from './ui-view-implementation.js';
import UIView from './ui-view.js';

export default UIView;
export const UIViewImplementation = _UIViewImplementation;
